function getSvg() {
  return process.env.PUBLIC_URL + '/sprite.svg';
}

export default getSvg;
